import { createSelector } from 'reselect';

import getCurrentOrder from './getCurrentOrder';

export const getLoyaltyTopUpValue = createSelector(
  [getCurrentOrder],
  order => order.loyaltyTopUp,
);
